import { motion, useReducedMotion } from "framer-motion";

const OFFSETS = {
  up: { y: 36, x: 0 },
  down: { y: -36, x: 0 },
  left: { x: -44, y: 0 },
  right: { x: 44, y: 0 },
  scale: { x: 0, y: 20 },
};

const Reveal = ({
  children,
  direction = "up",
  delay = 0,
  duration = 0.55,
  className = "",
  amount = 0.15,
  as = "div",
  ...rest
}) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    return (
      <MotionTag className={className} {...rest}>
        {children}
      </MotionTag>
    );
  }

  const off = OFFSETS[direction] || OFFSETS.up;
  return (
    <MotionTag
      initial={{ opacity: 0, x: off.x, y: off.y, scale: direction === "scale" ? 0.96 : 1 }}
      whileInView={{ opacity: 1, x: 0, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.01, margin: "0px 0px 120px 0px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
